module.exports = __webpack_public_path__ + "media/images/staff_feature-76ab6b1378c0be6ee5d041da6917dd20.jpg";